// extracted by mini-css-extract-plugin
export default {"container":"SlopeAccordion_container__mfKeA","details":"SlopeAccordion_details__1ai9s"};